module.exports = __webpack_public_path__ + "img/002-cloudy.3234dff0.svg";